"use client";

import React from "react";
import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

interface LitigationsClaimsSubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  onSelect?: (section: string) => void;
  area?: "Planning" | "Execution" | "ConcludingProcedures";
}

export default function LitigationsClaimsSubstantive({ 
  onBack, 
  setActiveSection,
  onSelect,
  area = "ConcludingProcedures"
}: LitigationsClaimsSubstantiveProps) {
  // Prefer onSelect when provided (used by main-content routing),
  // fall back to setActiveSection for backward compatibility.
  const navigate = onSelect ?? setActiveSection;

  return (
    <GenericSubstantiveProcedures
      workspaceName="Litigations & Claims"
      area={area}
      onBack={onBack}
      setActiveSection={navigate}
    />
  );
}
